/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.TranslationsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './TranslationsRpc';
import * as Queries from './TranslationsRpc.dfc.new';
import type { AdditionalContextArgs } from './TranslationsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseListPortalTranslationsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListPortalTranslationsResponseType>,
    References.ListPortalTranslationsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listPortalTranslations',
            References.ListPortalTranslationsResponseType
          >
        : References.ListPortalTranslationsResponseType)
    | undefined;
};

export function useListPortalTranslationsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListPortalTranslationsResponseType>,
    References.ListPortalTranslationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListPortalTranslationsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_PORTAL_TRANSLATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listPortalTranslations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListPortalTranslationsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListPortalTranslationsQueryReturn<T>;
}

type UseListPortalTranslationsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListPortalTranslationsResponseType>,
    References.ListPortalTranslationsRequestType,
    T extends true
      ? Record<
          'listPortalTranslations',
          References.ListPortalTranslationsResponseType
        >
      : References.ListPortalTranslationsResponseType
  >;

export function useListPortalTranslationsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListPortalTranslationsResponseType>,
    References.ListPortalTranslationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListPortalTranslationsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_PORTAL_TRANSLATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listPortalTranslations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListPortalTranslationsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListPortalTranslationsLazyQueryReturn<T>;
}

type UseListPortalTranslationsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListPortalTranslationsResponseType>,
    References.ListPortalTranslationsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listPortalTranslations',
        References.ListPortalTranslationsResponseType
      >
    : References.ListPortalTranslationsResponseType;
};

export function useListPortalTranslationsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListPortalTranslationsResponseType>,
    References.ListPortalTranslationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListPortalTranslationsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_PORTAL_TRANSLATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listPortalTranslations: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListPortalTranslationsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListPortalTranslationsSuspenseQueryReturn<T>;
}
